export default function ContactMap() {
  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Service <strong>Area</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Based in <strong>Watford</strong>, we provide professional <strong>painting and decorating services</strong> throughout <strong>Hertfordshire</strong>
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="aspect-video w-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39520.89384847!2d-0.4195!3d51.6565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48766f2f3f3f3f3f%3A0x3f3f3f3f3f3f3f3f!2sWatford%2C%20UK!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Brushour Service Area Map"
            ></iframe>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-3">
              <i className="ri-map-pin-line text-xl text-blue-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-800 mb-1">Watford</h4>
            <p className="text-xs text-gray-600">Main Area</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-3">
              <i className="ri-map-pin-line text-xl text-blue-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-800 mb-1">Bushey</h4>
            <p className="text-xs text-gray-600">Service Area</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-3">
              <i className="ri-map-pin-line text-xl text-blue-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-800 mb-1">Pinner</h4>
            <p className="text-xs text-gray-600">Service Area</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-3">
              <i className="ri-map-pin-line text-xl text-blue-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-800 mb-1">Radlett</h4>
            <p className="text-xs text-gray-600">Service Area</p>
          </div>
        </div>
      </div>
    </section>
  );
}
